import React from "react";
import { FlexContainer } from "./UI";
// import { FooterContainer } from "./UI";
// import ContactUs from "./ContactUs";
// import People from "./People";
// import Resources from "./Resources";
import Copyright from "./Copyright";

const Footer = () => {
    return (
        <FlexContainer noBottom>
            {/* <FooterContainer>
                <ContactUs />
                <People />
                <Resources />
            </FooterContainer> */}
            <Copyright />
        </FlexContainer>
    );
};
export default Footer;
